import { useNavigate } from 'react-router-dom';

import './home-page.css';
import { WALLBOARDS_URL } from "../../config";
import { PageFooterContent, PageHeaderButtons } from '../menu';

import { 
    PageFooter, 
    PageHeader, 
    PageLayout, 
    PageSection, 
    PageMenu, 
    Header, 
    Button,
    Icon,
} from '../../components/components';

export function HomePage() {
    const navigate = useNavigate();

    return (
        <PageLayout 
            header={<PageHeader name="Puzzel wallboards" menu={<PageMenu><PageHeaderButtons /></PageMenu>} />}
            footer={<PageFooter><PageFooterContent /></PageFooter>}>
            <PageSection class="full-width homepage-section">
                <div>
                    <Header>
                        Wallboards
                    </Header>
                    <p className="homepage-section-text">
                        Monitor your Puzzel queues in real-time.
                    </p>
                    <Button  
                        variant="secondary"
                        icon="ic_selfservice"
                        clicked={() => navigate(WALLBOARDS_URL)}>
                        Explore wallboards
                    </Button>
                </div>
                <div>
                    <Icon 
                        name="manypixels_wallboard" 
                        class="illustration">
                    </Icon>
                </div>
            </PageSection>
        </PageLayout>
    );
}